import { ALGOS_E } from "@constants/Algos";
import { MinerLocationRaw, IMiningPlanOptions } from "@services/getMinerList";
import { IMinerProfile } from "@store/minerProfiles/reducer";

export interface ISavedMinerSetting {
  readonly cloned_miner: string;
  readonly notes: string;
  readonly speed_drop: number;
  readonly miner_type: IMinerProfile;
  readonly mining_persent: number;
  readonly default_speed: number;
  readonly miner_plan?: IMiningPlanOptions;
  readonly admin_setting?: string;
  readonly location?: MinerLocationRaw;
  readonly hash: ALGOS_E;
  // readonly setting: string;
  readonly customer: {
    customer_email: string;
    customer_id: string;
    customer_uuid: string;
    customer_name: string;
  };
}

export enum ActionTypesSavedSettingsE {
  SET_SAVED_SETTINGS = "SET_SAVED_SETTINGS",
  ADD_SAVED_SETTINGS = "ADD_SAVED_SETTINGS",
  REMOVE_SAVED_SETTING = "REMOVE_SAVED_SETTING",
  CLEAR_SAVED_SETTINGS = "CLEAR_SAVED_SETTINGS",
}

export interface ActionBaseSavedSettings {
  type: ActionTypesSavedSettingsE;
}

export interface ActionSetSavedSettings extends ActionBaseSavedSettings {
  payload: {
    savedSettings: ISavedMinerSetting[];
  };
}

export interface ActionAddSavedSetting extends ActionBaseSavedSettings {
  payload: {
    newSavedSetting: ISavedMinerSetting;
  };
}

export interface ActionRemoveSavedSetting extends ActionBaseSavedSettings {
  payload: ISavedMinerSetting["cloned_miner"];
}

export interface ActionClearSavedSettings extends ActionBaseSavedSettings { }
